import { Box, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// svg
import { ReactComponent as IconTooltip } from "../../assets/svg/help-circle.svg";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.default,
    fontSize: 12,
    /*   boxShadow: theme.shadows[1],
     fontSize: 11 */
  },
}));

export const TooltipWithIconCustom = ({
  text,
  placement = "right",
  color = "#B5B7C1",
  size = "14px",
  children,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      {children}
      <StyledTooltip
        title={<Typography fontSize={"12px"}>{text}</Typography>}
        placement={placement}
      >
        <Box>
          <IconTooltip
            width={size}
            height={size}
            stroke={color}
            style={{ cursor: "help" }}
          />
        </Box>
      </StyledTooltip>
    </Box>
  );
};

export const TooltipCustom = ({ text, placement = "right", children }) => {
  return (
    <StyledTooltip
      title={<Typography fontSize={"12px"}>{text}</Typography>}
      placement={placement}
    >
      {children}
    </StyledTooltip>
  );
};

export const TooltipControlled = ({
  text,
  placement = "bottom",
  color = "#B5B7C1",
  size = "14px",
  children,
  open,
  handleClose,
  handleOpen,
}) => {
  return (
    <StyledTooltip
      arrow
      title={<Typography fontSize={"12px"}>{text}</Typography>}
      placement={placement}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
    >
      {children}
    </StyledTooltip>
  );
};
